import { Component, OnInit } from '@angular/core';
import { FooterLabel_EN } from '../../../models/labels/footerLabel_EN';
import { LoginRenderingService } from '../../../services/login/login-rendering.service';
import { ApiService } from '../../../services/api/api.service';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { AboutUsComponent } from './about-us/about-us.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  label: any;
  footerImg: String;
  constructor(private loginRenderingService: LoginRenderingService,
    private loginService: LoginRenderingService, private data: ApiService, public dialog: MatDialog) { }

  ngOnInit() {
    this.label = new FooterLabel_EN();
  }

  public footerImage() {
    this.footerImg = this.data.setFooterImage();
    return this.footerImg;
  }

  openAbout() {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.panelClass = 'about';
    dialogConfig.autoFocus = false;
    this.dialog.open(AboutUsComponent, dialogConfig);
  }

  openPrivacy() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'about';
    dialogConfig.autoFocus = false;
    this.dialog.open(PrivacyComponent, dialogConfig);
  }

  openTerms() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'about';
    dialogConfig.autoFocus = false;
    this.dialog.open(TermsAndConditionsComponent, dialogConfig);
  }
}
